'use client';

import { c as _c } from "react/compiler-runtime";
import { Grid3x3Icon, ListIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ItemsViewModeEnum } from '@/enums';
type PropsType = {
  viewMode: ItemsViewModeEnum;
  onViewModeChange: (mode: ItemsViewModeEnum) => void;
};
const ItemsViewModeToggle = t0 => {
  const $ = _c(15);
  const {
    viewMode,
    onViewModeChange
  } = t0;
  const t1 = viewMode === ItemsViewModeEnum.GRID ? "gray" : "ghost";
  let t2;
  if ($[0] !== onViewModeChange) {
    t2 = () => onViewModeChange(ItemsViewModeEnum.GRID);
    $[0] = onViewModeChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Grid3x3Icon />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2) {
    t4 = <Button variant={t1} size="icon" onClick={t2} className="h-7 w-7 p-0" aria-label="Grid view">{t3}</Button>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = viewMode === ItemsViewModeEnum.LIST ? "gray" : "ghost";
  let t6;
  if ($[6] !== onViewModeChange) {
    t6 = () => onViewModeChange(ItemsViewModeEnum.LIST);
    $[6] = onViewModeChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ListIcon />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6) {
    t8 = <Button variant={t5} size="icon" onClick={t6} className="h-7 w-7 p-0" aria-label="List view">{t7}</Button>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <div className="hidden items-center gap-1 rounded-md border p-1 sm:flex">{t4}{t8}</div>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default ItemsViewModeToggle;